<script lang="ts">
    import CalculatorShinerBox from "./CalculatorShinerBox.svelte";

    function explanationFromProbability(probability: number): string {
        if (probability <= 0) {
            return "Impossible";
        } else if (probability < 0.25) {
            return "Very Unlikely";
        } else if (probability < 0.4) {
            return "Unlikely";
        } else if (probability < 0.6) {
            return "50/50";
        } else if (probability < 0.8) {
            return "Likely";
        } else if (probability < 1) {
            return "Very Likely";
        } else {
            return "Literally can't fail";
        }
    }

    function calculateBorderColorFromProbability(probability: number): string {
        if (probability < 0.3) {
            return "red";
        } else if (probability < 0.7) {
            return "blue";
        } else {
            return "green";
        }
    }

    let shineBox;
    export let percentSuccess;
    let borderColor = "blue";
    $: resultExplanation = explanationFromProbability(percentSuccess / 100.0);
    $: if (percentSuccess) {
        borderColor = calculateBorderColorFromProbability(
            percentSuccess / 100.0,
        );
        shineBox.shine();
    }
</script>

<CalculatorShinerBox {borderColor} bind:this={shineBox} >
    {#if percentSuccess !== null}
        <div class="result {borderColor}">
            <div
                class="explanation padding-left-5px padding-right-5px center-contents-v font-size-1-5-rem"
            >
                {resultExplanation}
            </div>
            <div
                class="number padding-left-5px padding-right-5px center-contents-v font-family-bardic-sans"
            >
                {#if percentSuccess < 100 && percentSuccess > 0}
                    <div class="font-size-1-5-rem">
                        {percentSuccess.toFixed(0)}%
                    </div>
                {/if}
                {#if percentSuccess >= 100}
                    <div class="text-align-center">(Just Dodge the Nat 1)</div>
                {/if}
                {#if percentSuccess <= 0}
                    <div class="text-align-center">(Pray for that Nat 20)</div>
                {/if}
            </div>
        </div>
    {:else}
        <em class="background-color-pico-background"
            >Enter values to know your chances</em
        >
    {/if}
</CalculatorShinerBox>
